import { useContext } from 'react'

import { StringsContext } from '@lib/strings-context'

import Accordion from '@components/accordion'

interface ProductDimensionsProps {
  title?: string
  artworkSizeString?: string
  innerFrameSizeString?: string
  outerFrameSizeString?: string
  passepartoutSizeString?: string
  passepartoutHoleSizeString?: string
  isOpenByDefault?: boolean
  className?: string
}

const ProductDimensions = ({
  title,
  artworkSizeString,
  innerFrameSizeString,
  outerFrameSizeString,
  passepartoutSizeString,
  passepartoutHoleSizeString,
  isOpenByDefault,
  className,
}: ProductDimensionsProps) => {
  const strings = useContext(StringsContext)

  const hasAnySizeString =
    !!artworkSizeString ||
    !!innerFrameSizeString ||
    !!outerFrameSizeString ||
    !!passepartoutSizeString ||
    !!passepartoutHoleSizeString

  return (
    <Accordion
      id="product-dimensions"
      title={title}
      isOpenByDefault={isOpenByDefault}
      className={className}
    >
      {hasAnySizeString && (
        <div className="flex gap-2">
          <div className="text-sm">
            {!!artworkSizeString && (
              <div>{strings.productArtworkSizeLabel}:</div>
            )}
            {!!innerFrameSizeString && (
              <div>{strings.productInnerFrameSizeLabel}:</div>
            )}
            {!!outerFrameSizeString && (
              <div>{strings.productOuterFrameSizeLabel}:</div>
            )}
            {!!passepartoutSizeString && (
              <div>{strings.productPassepartoutSizeLabel}:</div>
            )}
            {!!passepartoutHoleSizeString && (
              <div>{strings.productPassepartoutHoleSizeLabel}:</div>
            )}
          </div>
          <div className="text-sm">
            {!!artworkSizeString && <div>{artworkSizeString}</div>}
            {!!innerFrameSizeString && <div>{innerFrameSizeString}</div>}
            {!!outerFrameSizeString && <div>{outerFrameSizeString}</div>}
            {!!passepartoutSizeString && <div>{passepartoutSizeString}</div>}
            {!!passepartoutHoleSizeString && (
              <div>{passepartoutHoleSizeString}</div>
            )}
          </div>
        </div>
      )}

      {!hasAnySizeString && (
        <p className="text-sm">{strings.productFrameDimensionsSizeMissing}</p>
      )}
    </Accordion>
  )
}

export default ProductDimensions
